import React from "react";
import Data from "./Data";
import axios from "axios";
import $ from "jquery";
import { useState, useEffect } from "react";
import {
  Text,
  Card,
  Col,
  Row,
  Button,
  Dropdown,
  Modal,
} from "@nextui-org/react";
import {
  AccordionSummary,
  AccordionDetails,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import { GrClose } from "react-icons/gr";
import { MdOutlineExpandMore } from "react-icons/md";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import ClassesPanelListItem from "./ClassesPanelListItem";
import { BiTimeFive } from "react-icons/bi";
import { useSnackbar } from "notistack";
import { classesActions } from "../Store/classesSlice";
import { useRef } from "react";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: 0,
  background: "transparent",
  "&:before": {
    display: "none",
  },
}));

function ClassesPanelList(props) {
  const { dayid, index } = props;
  const dispatch = useDispatch();
  const modalRef = useRef(null);
  const data = useSelector((state) => state.classes.items[index]);
  const items = useSelector((state) => state.classes.items[index]["infos"]);
  const [openMessage, setOpenMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [newDayId, setNewDayId] = useState(dayid);
  const [positiveNegative, setPositiveNegative] = useState("+");
  const [duty, setDuty] = useState("کنسلی");
  const [messageStatus, setMessageStatus] = useState("info");
  const [dialog, setDialog] = useState(<div />);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openChangeDayModal, setOpenChangeDayModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openClassModal, setOpenClassModal] = useState(false);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const modalClose = () => {
    setOpenDeleteModal(false);
    setOpenChangeDayModal(false);
    setOpenCancelModal(false);
    setOpenClassModal(false);
  };

  const openDelete = () => {
    setOpenDeleteModal(true);
  };

  const handleMenu = (key) => {
    setNewDayId(key);
    setOpenChangeDayModal(true);
  };

  const openCancel = (doo) => {
    setPositiveNegative(doo);
    setOpenCancelModal(true);
  };
  const openClass = () => {
    setOpenClassModal(true);
  };

  const handleDelete = () => {
    modalClose();

    $("#waitspinner").modal("show");

    let token = localStorage.getItem("token");
    let data1 = new FormData();
    data1.append("token", "");
    data1.append("instrumentid", data["instrumentid"]);
    data1.append("dayid", dayid);
    axios
      .post(Data.server + `deleteClass.php`, data1)
      .then((response) => {
        $("#waitspinner").modal("hide");

        if (response.data === "ok") {
          enqueueSnackbar("کلاس با موفقیت حذف شد", { variant: "success" });
          dispatch(classesActions.empty());
        } else {
          enqueueSnackbar("خطای داخلی رخ داد", { variant: "error" });
        }
      })
      .catch((error) => {
        console.log(error);
        enqueueSnackbar("خطای داخلی رخ داد", { variant: "error" });
        $("#waitspinner").modal("hide");
      });
  };
  const handleChangeDay = () => {
    let newday = days[newDayId].day;
    modalClose();

    $("#waitspinner").modal("show");

    let data1 = new FormData();
    data1.append("dayid", dayid);
    data1.append("masterid", data["masterid"]);
    data1.append("instrumentid", data["instrumentid"]);
    data1.append("newdayid", newDayId);
    data1.append("newday", newday);

    axios
      .post(Data.server + "editClasses.php", data1)
      .then((response) => {
        $("#waitspinner").modal("hide");

        if (response.data === "ok") {
          enqueueSnackbar("کلاس با موفقیت جابجا شد", { variant: "success" });
          dispatch(classesActions.empty());
        }

        if (response.data.includes("error update")) {
          enqueueSnackbar("خطای داخلی رخ داد", { variant: "error" });
        }
      })
      .catch((error) => {
        $("#waitspinner").modal("hide");
        enqueueSnackbar("خطای داخلی رخ داد", { variant: "error" });
        console.log(error);
      });
  };

  const handleCancel = (doo) => {
    modalClose();
    $("#waitspinner").modal("show");

    let data1 = new FormData();
    data1.append("dayid", dayid);
    data1.append("masterid", data["masterid"]);
    data1.append("do", doo);

    axios
      .post(Data.mainserver + "cancelClass.php", data1)
      .then((response) => {
        console.log("dataaaaa", response.data);
        $("#waitspinner").modal("hide");

        if (response.data === "ok") {
          enqueueSnackbar("ویرایش با موفقیت ثبت شد", { variant: "success" });
          dispatch(classesActions.empty());
        } else {
          enqueueSnackbar("خطای داخلی رخ داد", { variant: "error" });
        }
      })
      .catch((error) => {
        console.log(error);
        $("#waitspinner").modal("hide");
      });
  };

  const showMessage = (msg, status) => {
    setMessage(msg);
    setMessageStatus(status);
    setOpenMessage(true);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenMessage(false);
  };
  const action = (
    <div
      className="text-white"
      style={{ alignItems: "center", margin: "0px", padding: "0px" }}
    >
      <GrClose className="m-0 p-0" onClick={handleClose} />
    </div>
  );

  const days = [
    { id: 0, day: "شنبه" },
    { id: 1, day: "یکشنبه" },
    { id: 2, day: "دوشنبه" },
    { id: 3, day: "سه شنبه" },
    { id: 4, day: "چهارشنبه" },
    { id: 5, day: "پنج شنبه" },
  ];
  useEffect(() => {
    if (positiveNegative == "-") {
      setDuty("جبرانی");
    }
    if (positiveNegative == "+") {
      setDuty("کنسلی");
    }
  }, [positiveNegative]);

  return (
    <div className="col-md-6 col-sm-12 text-right mx-auto p-3">
      <Card isHoverable variant="bordered" className="w-100 h-100">
        <Card.Body css={{ p: 0 }}>
          <Card.Image
            src={Data.mainserver + "images/" + data["masterpicture"]}
            objectFit="cover"
            width="100%"
            height="100%"
          />
          <div
            className="d-flex flex-row-reverse"
            style={{ position: "absolute", left: "15px", top: "15px" }}
          >
            <Button
              onPress={openDelete}
              auto
              color="error"
              size="sm"
              style={{ margin: "6px" }}
            >
              حذف
            </Button>
            <Dropdown placement="bottom-center">
              <Dropdown.Trigger>
                <Button
                  flat
                  auto
                  size="sm"
                  color="secondary"
                  style={{ margin: "6px" }}
                >
                  تغییر روز
                </Button>
              </Dropdown.Trigger>
              <Dropdown.Menu
                aria-label="User menu actions"
                color="secondary"
                variant="solid"
                className="text-right"
                onAction={(actionKey) => handleMenu(actionKey)}
              >
                {days.map((d) =>
                  d.id != dayid ? (
                    <Dropdown.Item
                      icon={<BiTimeFive className="mx-1" />}
                      key={d.id}
                    >
                      {d.day}
                    </Dropdown.Item>
                  ) : null
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div
            className="d-flex flex-row-reverse"
            style={{ position: "absolute", left: "15px", top: "60px" }}
          >
            <Button.Group size="sm" style={{ direction: "initial" }} flat>
              <Button onPress={(e) => openCancel("+")}>کنسلی</Button>
              <Button onPress={(e) => openCancel("-")}>جبرانی</Button>
            </Button.Group>
          </div>
          <Modal
            blur
            closeButton
            aria-labelledby="modal-title"
            open={openDeleteModal}
            onClose={modalClose}
          >
            <Modal.Header>
              <Text id="modal-title" size={18}>
                حدف
                <Text b size={18} css={{ tt: "capitalize" }}>
                  {" " + data["mastername"]}
                </Text>
              </Text>
            </Modal.Header>
            <Modal.Body>
              <Text id="modal-title" size={18}>
                {"آیا از حدف استاد " +
                  data["mastername"] +
                  " مدرس " +
                  data["instrumentname"] +
                  " در روزهای " +
                  days[dayid].day +
                  " مطمئن هستید ؟"}
              </Text>
            </Modal.Body>
            <Modal.Footer>
              <Button auto flat color="error" onPress={modalClose}>
                لغو
              </Button>
              <Button
                auto
                color="secondary"
                type="submit"
                onPress={handleDelete.bind(this)}
              >
                حذف
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            blur
            closeButton
            aria-labelledby="modal-title"
            open={openChangeDayModal}
            onClose={modalClose}
          >
            <Modal.Header>
              <Text id="modal-title" size={18}>
                جابجایی کلاس
                <br />
                <Text b size={18} css={{ tt: "capitalize" }}>
                  {" " +
                    data["instrumentname"] +
                    " استاد " +
                    data["mastername"]}
                </Text>
              </Text>
            </Modal.Header>
            <Modal.Body>
              <Text id="modal-title" size={18}>
                {"آیا از جابجایی کلاس " +
                  data["instrumentname"] +
                  " استاد " +
                  data["mastername"] +
                  " به روز " +
                  days[newDayId].day +
                  " مطمئن هستید ؟"}
              </Text>
            </Modal.Body>
            <Modal.Footer>
              <Button auto flat color="error" onPress={modalClose}>
                لغو
              </Button>
              <Button
                auto
                color="secondary"
                type="submit"
                onPress={handleChangeDay}
              >
                جابجا
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            blur
            closeButton
            aria-labelledby="modal-title"
            open={openCancelModal}
            onClose={modalClose}
          >
            <Modal.Header>
              <Text id="modal-title" size={18}>
                {duty + " "} کلاس
                <br />
                <Text b size={18} css={{ tt: "capitalize" }}>
                  {" " +
                    data["instrumentname"] +
                    " استاد " +
                    data["mastername"]}
                </Text>
              </Text>
            </Modal.Header>
            <Modal.Body>
              <Text id="modal-title" size={18}>
                {"آیا از ثبت  " +
                  duty +
                  " برای کلاس " +
                  data["instrumentname"] +
                  " استاد " +
                  data["mastername"] +
                  " مطمئن هستید ؟"}
              </Text>
            </Modal.Body>
            <Modal.Footer>
              <Button auto flat color="error" onPress={modalClose}>
                لغو
              </Button>
              <Button
                auto
                color="secondary"
                type="submit"
                onPress={(e) => handleCancel(positiveNegative)}
              >
                {duty}
              </Button>
            </Modal.Footer>
          </Modal>
        </Card.Body>
        <Card.Footer>
          <div className="w-100">
            <Row>
              <Col span={3}>
                <div
                  style={{
                    position: "relative",
                    maxHeight: "64px",
                    maxWidth: "64px",
                  }}
                >
                  <img
                    className="circle-icon max-72 centercrop"
                    height="64px"
                    width="64px"
                    src={
                      data["masterpic"] === ""
                        ? Data.mainserver + "icons/user.png"
                        : Data.mainserver + "images/" + data["masterpic"]
                    }
                  />
                  <div
                    className="circle-inst"
                    style={{
                      position: "absolute",
                      bottom: "-7px",
                      left: "-7px",
                    }}
                  >
                    <img
                      height="16px"
                      width="16px"
                      src={Data.server + "icons/" + data["instrumentpic"]}
                    />
                  </div>
                </div>
              </Col>
              <Col className="mr-3">
                <Text color="#000" size={16}>
                  {data["mastername"]}
                </Text>
                <Text color="#000" size={16}>
                  {data["instrumentname"]}
                </Text>
              </Col>
			  <Col className="mr-auto mt-auto mb-auto">
				<Button className="mr-auto" onPress={openClass} auto color="secondary">
					کلاس ها
				</Button>
			  </Col>
            </Row>
			<Modal
				closeButton
				width="750px"
				aria-labelledby="modal-title"
				open={openClassModal}
				onClose={modalClose}
			>
				<Modal.Header>
				  <Text id="modal-title" size={18}>
					{"کلاس های " + days[dayid].day}
					<br />
					<Text b size={18} css={{ tt: "capitalize" }}>
					  {" " +
						data["instrumentname"] +
						" استاد " +
						data["mastername"]}
					</Text>
				  </Text>
				</Modal.Header>
				<Modal.Body>
				  <Table
               aria-label="Example static bordered collection table"
               css={{
                 height: "auto",
                 minWidth: "100%",
               }}
             >
               <TableHead>
                 <TableRow>
                   <TableCell align='center'>ساعت</TableCell>
                   <TableCell align='center'>وضعیت</TableCell>
                   <TableCell align='center'>تاریخ رزرو</TableCell>
                   <TableCell align='center'>مشخصات</TableCell>
                   <TableCell align='center'></TableCell>
                 </TableRow>
               </TableHead>
               <TableBody>
                 {items.map((d,i) =>

                   <ClassesPanelListItem key={i} indexParent={index} index={i}/>

                 )}
               </TableBody>
            </Table>
				</Modal.Body>
				<Modal.Footer>
				  <Button auto flat color="error" onPress={modalClose}>
					بستن
				  </Button>
				  
				</Modal.Footer>
			</Modal>
          </div>
        </Card.Footer>
      </Card>
    </div>

    // <Accordion className='mb-3' key={index} style={{minHeight: '400px'}}>

    //     <AccordionDetails>
    //         <Table
    //           aria-label="Example static bordered collection table"
    //           css={{
    //             height: "auto",
    //             minWidth: "100%",
    //           }}
    //         >
    //           <TableHead>
    //             <TableRow>
    //               <TableCell align='center'>ساعت</TableCell>
    //               <TableCell align='center'>وضعیت</TableCell>
    //               <TableCell align='center'>تاریخ رزرو</TableCell>
    //               <TableCell align='center'>مشخصات</TableCell>
    //               <TableCell align='center'></TableCell>
    //             </TableRow>
    //           </TableHead>
    //           <TableBody>
    //             {items.map((d,i) =>

    //               <ClassesPanelListItem key={i} indexParent={index} index={i}/>

    //             )}
    //           </TableBody>
    //         </Table>
    //     </AccordionDetails>

    // </Accordion>
  );
}

export default ClassesPanelList;
